(function () {
  'use strict';

  var dataEl = document.getElementById('iphone-specs-data');
  if (!dataEl) return;

  var models = [];
  try {
    models = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  // specs セクションが出力した handle → collection image URL のマップを取得
  var imageMap = {};
  var mapEl = document.getElementById('hikaku-model-image-map');
  if (mapEl) {
    try {
      imageMap = JSON.parse(mapEl.textContent) || {};
    } catch (e) {
      imageMap = {};
    }
  }

  // JS側でも name に "/" を含むエントリを除外（Liquid側フィルタの安全策）
  models = models.filter(function (m) {
    return m.name && m.name.indexOf('/') === -1;
  });

  // release-date 降順ソート（新しい順）
  models.sort(function (a, b) {
    var dateA = parseReleaseDate(a.releaseDate);
    var dateB = parseReleaseDate(b.releaseDate);
    return dateB - dateA;
  });

  function parseReleaseDate(val) {
    if (!val) return 0;
    // "2023/9/22" or "2023年9月22日" 形式に対応
    var cleaned = String(val).replace(/年|月/g, '/').replace(/日/g, '');
    var ts = Date.parse(cleaned);
    return isNaN(ts) ? 0 : ts;
  }

  var select1 = document.getElementById('hikaku-select-1');
  var select2 = document.getElementById('hikaku-select-2');
  var image1 = document.getElementById('hikaku-image-1');
  var image2 = document.getElementById('hikaku-image-2');
  var tableContainer = document.getElementById('hikaku-compare-table');

  if (!select1 || !select2 || !tableContainer) return;

  // 両方のドロップダウンにオプションを追加
  populateSelect(select1);
  populateSelect(select2);

  function populateSelect(selectEl) {
    models.forEach(function (model) {
      var opt = document.createElement('option');
      opt.value = model.handle;
      opt.textContent = model.name;
      selectEl.appendChild(opt);
    });
  }

  function findModel(handle) {
    for (var i = 0; i < models.length; i++) {
      if (models[i].handle === handle) return models[i];
    }
    return null;
  }

  function renderImage(container, model) {
    if (!container) return;
    var src = model && (imageMap[model.handle] || model.collectionImage || model.thumbnail);
    if (src) {
      container.innerHTML = '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(model.name) + '" class="hikaku-product-image__img" loading="lazy" width="300" height="300">';
    } else {
      container.innerHTML = '';
    }
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function safeArray(val) {
    return Array.isArray(val) ? val : [];
  }

  function safeString(val) {
    if (val == null) return '';
    return String(val);
  }

  function formatArray(val) {
    return safeArray(val).join(', ') || safeString(val);
  }

  function formatWeight(val) {
    var arr = safeArray(val);
    if (arr.length > 0) return arr.join('、') + 'g';
    var s = safeString(val);
    return s ? s + 'g' : '';
  }

  function formatScreenSize(val) {
    var arr = safeArray(val);
    if (arr.length > 0) {
      return arr.map(function (s) { return s + 'インチ'; }).join(' / ');
    }
    var s = safeString(val);
    return s ? s + 'インチ' : '';
  }

  // スペック行の定義
  var specRows = [
    { label: 'カラー', key: 'color', format: formatArray },
    { label: 'ストレージ', key: 'storage', format: formatArray },
    { label: '本体サイズ', key: 'size', format: formatArray },
    { label: '画面サイズ', key: 'screenSize', format: formatScreenSize },
    { label: '重量', key: 'weight', format: formatWeight },
    { label: 'SIM', key: 'sim', format: formatArray },
    { label: '防水等級', key: 'ip', format: function (v) { return v || ''; } },
    { label: '接続方式', key: 'connectionType', format: formatArray },
    { label: 'フロントカメラ', key: 'frontCamera', format: function (v) { return v || ''; } },
    { label: 'バックカメラ', key: 'backCamera', format: function (v) { return v || ''; } },
    { label: '発売日', key: 'releaseDate', format: function (v) { return v || ''; } },
    { label: 'その他機能', key: 'others', format: formatArray }
  ];

  function normalizeForCompare(val) {
    if (Array.isArray(val)) return val.slice().sort().join(',');
    return safeString(val);
  }

  function getField(model, key) {
    var val = model[key];
    return val == null ? '' : val;
  }

  function renderCompareTable() {
    var handle1 = select1.value;
    var handle2 = select2.value;

    var m1 = handle1 ? findModel(handle1) : null;
    var m2 = handle2 ? findModel(handle2) : null;

    renderImage(image1, m1);
    renderImage(image2, m2);

    if (!m1 && !m2) {
      tableContainer.innerHTML = '';
      return;
    }

    var html = '<table class="hikaku-compare-table"><tbody>';
    html += '<tr class="hikaku-compare-table__header"><th></th>';
    html += '<td>' + escapeHtml(m1 ? m1.name : '') + '</td>';
    html += '<td>' + escapeHtml(m2 ? m2.name : '') + '</td>';
    html += '</tr>';

    specRows.forEach(function (row) {
      var raw1 = m1 ? getField(m1, row.key) : '';
      var raw2 = m2 ? getField(m2, row.key) : '';
      var val1 = m1 ? row.format(raw1) : '';
      var val2 = m2 ? row.format(raw2) : '';

      var isDiff = false;
      if (m1 && m2) {
        isDiff = normalizeForCompare(raw1) !== normalizeForCompare(raw2);
      }

      var diffClass = isDiff ? ' hikaku-diff' : '';

      html += '<tr>';
      html += '<th>' + escapeHtml(row.label) + '</th>';
      html += '<td class="' + diffClass + '">' + escapeHtml(val1) + '</td>';
      html += '<td class="' + diffClass + '">' + escapeHtml(val2) + '</td>';
      html += '</tr>';
    });

    html += '</tbody></table>';
    tableContainer.innerHTML = html;
  }

  select1.addEventListener('change', renderCompareTable);
  select2.addEventListener('change', renderCompareTable);

  // 初期値をセットして比較テーブルを表示（全定義の後で呼び出す）
  select1.value = 'iphone-15';
  select2.value = 'iphone-17';
  renderCompareTable();
})();
